import type { MatchEvent } from "@motain/xpa-proto-files-web/lib/types/match_events";
import type { INormalizedMatchEvent } from "@/types/normalizedMatchEvent";

import { getCardIcon } from "./getCardIcon";
import { pxIcon } from "@/utils/helpers/pxIcon";
import { getGoalIcon } from "./getGoalIcon";
import { getPenaltyShootoutIcon } from "./getPenaltyShootoutIcon";

export const normalizeMatchEvents = (
  matchEvents: Array<MatchEvent>,
): Array<INormalizedMatchEvent> => {
  const initial: Array<INormalizedMatchEvent> = [];
  const normalizedMatchEvents = matchEvents.reduce(
    (prev, curr): Array<INormalizedMatchEvent> => {
      if (curr.type) {
        switch (curr.type.$case) {
          case "goal":
            return [
              ...prev,
              {
                uiKey: curr.uiKey,
                name: curr.name,
                side: curr.teamSide,
                timeline: curr.timeline,
                icon: getGoalIcon(curr.type.goal.type),
                playerName: curr.type.goal.scorer?.name ?? "",
                metaText: curr.type.goal.assistant?.name ?? curr.name,
                videoLink: curr.type.goal.clipTeaser,
              },
            ];
          case "card":
            return [
              ...prev,
              {
                uiKey: curr.uiKey,
                name: curr.name,
                side: curr.teamSide,
                timeline: curr.timeline,
                icon: getCardIcon(curr.type.card.type),
                playerName: curr.type.card.player?.name ?? "",
                videoLink: curr.type.card.clipTeaser,
              },
            ];
          case "substitution":
            return [
              ...prev,
              {
                uiKey: curr.uiKey,
                name: curr.name,
                side: curr.teamSide,
                timeline: curr.timeline,
                icon: pxIcon(
                  24,
                  "https://images.onefootball.com/cw/icons/substitution.svg",
                ),
                playerName: curr.type.substitution.playerIn?.name ?? "",
                metaText: curr.type.substitution.playerOut?.name ?? "",
                videoLink: undefined,
                isSubstitution: true,
              },
            ];
          case "penaltyShootout": {
            return [
              ...prev,
              {
                uiKey: curr.uiKey,
                name: curr.name,
                side: curr.teamSide,
                timeline: curr.timeline,
                icon: getPenaltyShootoutIcon(curr.type.penaltyShootout.type),
                playerName: curr.type.penaltyShootout.player?.name ?? "",
                metaText: curr.type.penaltyShootout.score,
                videoLink: curr.type.penaltyShootout.clipTeaser,
              },
            ];
          }
          default:
            return [...prev];
        }
      }
      return [];
    },
    initial,
  );

  return normalizedMatchEvents;
};
